import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import shouldBeLoggedIn from '#app/guards/should-be-logged-in'
import shouldBePostRegistered from '#app/guards/should-be-post-registered'
import StaffDataProvider from '#app/middlewares/providers/staff-data'
import { NavigatableLayout } from '#widgets/layouts/navigatable-layout'
import { keycloak } from '#shared/lib/auth'

export const Route = createFileRoute('/staff/_post-registration-required')({
  component: () => (
    <StaffDataProvider>
      <NavigatableLayout key="navigatable-layout">
        <Outlet />
      </NavigatableLayout>
    </StaffDataProvider>
  ),

  loader: async () => {
    await shouldBeLoggedIn()
    shouldBePostRegistered()

    if (import.meta.env.PUBLIC_PLATFORM === 'telegram' && !keycloak.didInitialize) {
      throw redirect({ to: '/staff/tg-preregister' })
    }
  },
})
